import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "large-checkbox text-center" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: 'option-' + _ctx.idname
    }, [
      (!_ctx.currentValue)
        ? (_openBlock(), _createBlock(_component_Icon, {
            key: 0,
            icon: _ctx.CircleCheckBoxEmpty,
            width: "40",
            height: "40"
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true),
      (_ctx.currentValue)
        ? (_openBlock(), _createBlock(_component_Icon, {
            key: 1,
            icon: _ctx.CircleCheckBoxChecked,
            width: "40",
            height: "40"
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true)
    ], 8, _hoisted_2),
    _withDirectives(_createElementVNode("input", {
      id: 'option-' + _ctx.idname,
      class: "form-check-input",
      type: "checkbox",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentValue) = $event))
    }, null, 8, _hoisted_3), [
      [_vModelCheckbox, _ctx.currentValue]
    ])
  ]))
}